import { useEffect, useState } from "react";
import AbsenList from "../components/AbsenList";
import { getDateToday } from "../../../Utils/externalFunctions";
import { useAbsensi } from "../../../Context/AbsensiContext";
import { useStaf } from "../../../Context/StafContext";

const AbsenListContain = ({isPNS, toggleIsPNS}) => {
  const absensiAPI = useAbsensi();
  const stafAPI = useStaf();

  const [dateFilter, setDateFilter] = useState(getDateToday("original"));

  const [data, setData] = useState({
    absen: [],
    detailAbsen: [],
    staf: [],
    lokasi: [],
  });
  const [pending, setPending] = useState({ absen: false });

  let isMounted = true;
  useEffect(() => {
    const fetchData = async () => {
      refreshStaff();
      refreshLokasi();
      refreshData();
    };

    if (isMounted) fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    refreshData();
  }, [dateFilter]);

  const refreshData = () => {
    refreshAbsen();
    refreshDetailAbsen();
  };

  const refreshAbsen = () => {
    setPending((prev) => ({ ...prev, absen: true }));
    absensiAPI.getAbsensiByDate(dateFilter)
      .then((res) => {
        setData((prev) => ({ ...prev, absen: res.data }));
      })
      .finally(() => {
        setPending((prev) => ({ ...prev, absen: false }));
      });
  };

  const refreshDetailAbsen = () => {
    absensiAPI.getDetailAbsensiByDate(dateFilter).then((res) => {
      setData((prev) => ({ ...prev, detailAbsen: res.data }));
    });
  };

  const refreshStaff = async () => {
    stafAPI.getStaf().then((res) => {
      setData((prev) => ({ ...prev, staf: res.data }));
    });
  };

  const refreshLokasi = async () => {
    absensiAPI.getLokasi().then((res) => {
      setData((prev) => ({ ...prev, lokasi: res.data }));
    });
  };

  const updateDateFilter = (newDate) => setDateFilter(newDate);

  return (
    <AbsenList
      data={data}
      resetState={refreshData}
      updateDateFilter={updateDateFilter}
      toggleIsPNS={toggleIsPNS}
      pending={pending?.absen}
      dateFilter={dateFilter}
      isPNS={isPNS}
    />
  );
};

export default AbsenListContain;
